import { render, staticRenderFns } from "./AddNewCategoriesForm.vue?vue&type=template&id=06787661"
import script from "./AddNewCategoriesForm.vue?vue&type=script&lang=ts"
export * from "./AddNewCategoriesForm.vue?vue&type=script&lang=ts"
import style0 from "./AddNewCategoriesForm.vue?vue&type=style&index=0&id=06787661&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports